import { Box, Container, Typography } from "@mui/material";
import React from "react";
import Navbar from "../../components/HomeLandingPage/Home/NavBar/Navbar";
import Footer from "../../components/HomeLandingPage/Home/Footer/Footer";

const TermsConditions = () => {
  return (
    <>
      <Box
        sx={{
          paddingLeft: "25px",
          paddingRight: "25px",
          boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
        }}
      >
        <Navbar />
      </Box>

      {/* Banner Section */}
      <Box
        sx={{
          backgroundColor: "#000",
          color: "#fff",
          textAlign: "center",
          py: { xs: 6, md: 10 },
          px: 3,
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h3"
            sx={{ fontWeight: 600, mb: 2, fontSize: { xs: "2rem", md: "3rem" } }}
          >
            Terms and Conditions
          </Typography>
          <Typography
            sx={{
              textAlign: "justify",
              hyphens: "auto",
              fontSize: { xs: "0.9rem", md: "1rem" },
              opacity: 0.8,
            }}
          >
            Welcome to GX Tickets, your ultimate destination for seamless
            event management and hassle-free ticket booking. At GX Tickets,
            we believe in making every event an unforgettable experience.
            Our platform is designed to connect event organizers with
            their audiences, providing a streamlined process for creating,
            promoting, and managing events of all sizes.
          </Typography>
        </Container>
      </Box>

      {/* Terms Section */}
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Section title="1. Use of Services" content="You must be at least 18 years old to use GX Tickets." />
        <Section title="2. User Content" content="You retain all rights to the content you upload." />
        <Section title="3. Intellectual Property" content="GX Tickets and its original content, features, and functionality are protected by intellectual property laws." />
        <Section title="4. Payment and Subscription" content="Some features of GX Tickets may require payment of fees." />
        <Section
          title="5. Google Contact Access"
          content="GX Tickets may request access to your Google Contacts when you choose to connect your Google account for event invitation purposes. This is done using the scope: https://www.googleapis.com/auth/contacts.readonly. This access is used solely to help you view and select your contacts when sending event invites. We do not store, retain, or share your contact data beyond the scope of this feature. You may revoke access at any time through your Google Account permissions."
        />
        <Section title="6. Termination" content="You may terminate your account at any time." />
        <Section title="7. Disclaimer of Warranties" content="GX Tickets is provided 'as is' without any warranties." />
        <Section title="8. Contact Us" content="If you have any questions about these Terms, please contact us." />
      </Container>

      <Box sx={{ mt: { xs: 5, md: 10 } }}>
        <Footer />
      </Box>
    </>
  );
};

const Section = ({ title, content }) => (
  <Box mb={4}>
    <Typography
      variant="h5"
      sx={{ fontWeight: 600, mb: 1, color: "#333" }}
    >
      {title}
    </Typography>
    <Typography sx={{ color: "#555", lineHeight: "1.6" }}>{content}</Typography>
  </Box>
);

export default TermsConditions;
